module.exports = __webpack_public_path__ + "static/media/card_image.6d4c4fd4.svg";